import React from 'react'
import { Col, Row, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import CustomButton from 'components/atoms/CustomButton';
import { Diners, Jcb, UnionPay, Visa, Mastercard, Amex, Discover, Card } from 'assets/images'
import { isExpired } from 'lib/utils';
import ErrorIcon from '@mui/icons-material/Error';
const CompanyPaymentCards = ({ data, onAddCard }) => {

  const is_default = data?.find(el => el?.is_default)

  const { t, i18n } = useTranslation();

  const renderCardIcon = (type) => {

    switch (type) {
      case "Visa":
        return <img width={28} src={Visa} alt="visa" />;
      case "Mastercard":
        return <img width={28} src={Mastercard} alt="mastercard" />;
      case "AmericanExpress":
        return <img width={28} src={Amex} alt="amex" />;
      case "Discover":
        return <img width={28} src={Discover} alt="discover" />;
      case "Diners":
        return <img width={28} src={Diners} alt="diners" />;
      case "JCB":
        return <img width={28} src={Jcb} alt="jcp" />;
      case "UnionPay":
        return <img width={28} src={UnionPay} alt="unionpay" />;
      default:
        return <img width={28} src={Card} alt="" />;
    }
  }
  return (
    <Row className="mb-4 pt-6">
      <Col span={6} className="pl-4 pr-2">
        <Typography.Title className="text-h2 font-manrope !text-white">
          {t("Pay.PaymentData")}
        </Typography.Title>
      </Col>
      <Col span={12} className="px-2">
        <div className="mb-2">
          <Typography.Text className="font-manrope font-semibold text-[#7A7A7A] text-md">
            {t("Pay.PaymentMethod")}
          </Typography.Text>


        </div>

        {data?.length > 0 && is_default ? (
          <>
            <div className='flex items-center'>
              {renderCardIcon(is_default?.card_type)}
              <Typography.Text className="font-manrope font-semibold text-[#7A7A7A] text-md ml-2">
                {is_default?.card_type} {t('Pay.EndsWith')} ****{is_default?.last_four_digit}
              </Typography.Text>


            </div>
            {isExpired(is_default?.expired_at).expired && (
              <div className='flex items-center'>

                <ErrorIcon style={{
                  width: '15px',
                  color: '#E53E3E'
                }} />

                <p className='text-xs font-normal text-[#E53E3E] ml-1'> {t('Pay.ExpiredAt')} {isExpired(is_default?.expired_at).formattedDate}</p>
              </div>

            )}
          </>

        ) : (
          <Typography.Text className="font-manrope font-semibold text-[#7A7A7A] text-md">
            {t('Pay.NoCardsAdded')}
          </Typography.Text>
        )}



      </Col>


      <Col span={6} className="pr-4 pl-2 text-right">
        <div className="mb-8">
          <CustomButton
            buttonColor={"secondary"}
            onClick={() => { onAddCard() }}
          >{t("Pay.ChangeMethod")}</CustomButton>
        </div>
      </Col>
    </Row>
  )
}

export default CompanyPaymentCards